import { render, staticRenderFns } from "./MemberRight.vue?vue&type=template&id=b52ecb4e&scoped=true"
import script from "./MemberRight.vue?vue&type=script&lang=js"
export * from "./MemberRight.vue?vue&type=script&lang=js"
import style0 from "./MemberRight.vue?vue&type=style&index=0&id=b52ecb4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52ecb4e",
  null
  
)

export default component.exports